"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const Response_1 = require("./Response");
const UrlBuilder_1 = require("./UrlBuilder");
class Request {
    constructor(configuration, accessTokenProvider) {
        this.retryCount = 1;
        this.retries = 0;
        this._configuration = configuration;
        this.accessTokenProvider = accessTokenProvider;
        this.client = axios_1.default.create(this.constructClientConfig());
    }
    get configuration() {
        return this._configuration;
    }
    get(endpoint, urlParams = null, config = {}) {
        return this.request(this.createRequest('GET', endpoint, urlParams, config));
    }
    post(endpoint, data, urlParams = null, config = {}) {
        return this.request(this.createRequest('POST', endpoint, urlParams, { ...config, data }));
    }
    put(endpoint, data, urlParams = null, config = {}) {
        return this.request(this.createRequest('PUT', endpoint, urlParams, { ...config, data }));
    }
    delete(endpoint, urlParams = null, config = {}) {
        return this.request(this.createRequest('DELETE', endpoint, urlParams, config));
    }
    request(request, resetRetries = true) {
        if (resetRetries) {
            this.retries = 0;
        }
        return this.client.request(request)
            .then((response) => {
            return new Response_1.Response(response.data, response.status, response.statusText);
        })
            .catch((error) => this.handleError(request, error));
    }
    createRequest(method, endpoint, urlParams = null, config = {}) {
        return {
            method: method,
            url: UrlBuilder_1.UrlBuilder.build(this.getEndpointUrl(endpoint), urlParams),
            ...config
        };
    }
    getEndpointUrl(endpoint) {
        return this._configuration.endpoints[endpoint];
    }
    handleError(request, error) {
        if (!this.configuration.auth || this.configuration.auth.method === null) {
            throw error;
        }
        if (this._configuration.auth.method === 'auth0') {
            return this.handleAuth0Error(request, error);
        }
        throw error;
    }
    handleAuth0Error(request, error) {
        if (error.response.status !== 401) {
            throw error;
        }
        return this.accessTokenProvider.refreshToken()
            .then(() => {
            this.retries += 1;
            if (this.retries > this.retryCount) {
                throw error;
            }
            this.updateHeaders(request);
            return this.request(request, false);
        });
    }
    constructClientConfig() {
        if (!this.configuration.auth || this.configuration.auth.method === null) {
            return {
                baseURL: this._configuration.url
            };
        }
        if (this._configuration.auth.method === 'basic_auth') {
            return {
                baseURL: this._configuration.url,
                auth: {
                    username: this._configuration.auth.basicAuth.username,
                    password: this._configuration.auth.basicAuth.password
                }
            };
        }
        if (this._configuration.auth.method === 'auth0') {
            return {
                baseURL: this._configuration.url,
                headers: this.getHeaders()
            };
        }
        throw new Error(`API authentication method (${this._configuration.auth.method}) not supported.`);
    }
    updateHeaders(request) {
        request.headers = this.getHeaders();
    }
    getHeaders() {
        return {
            'Authorization': `Bearer ${this.accessTokenProvider.getAccessToken()}`
        };
    }
}
exports.Request = Request;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-http-service/Services/Request.ts